export default "__VITE_ASSET__BZze7stf__"